import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import type { ReturnRequestShippingInfoDto } from "@babackapp/private-api-client";
import { motion } from "motion/react";

type Props = {
  shippingInfo: ReturnRequestShippingInfoDto;
};

export function ReturnMethodSection({ shippingInfo }: Props) {
  const t = useCustomText();

  const carrierName = shippingInfo.carrierTitle ?? shippingInfo.carrier;
  const trackingCode = shippingInfo.tracking_code;
  const isStoreReturn = !!shippingInfo.returnStoreId;

  if (!carrierName && !trackingCode && !isStoreReturn) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, delay: 0.1 }}
      className="flex flex-col gap-2 px-1"
    >
      <p className="text-sm font-medium text-foreground">
        {t("returnRequests.details.returnMethod")}
      </p>
      <div className="flex flex-col gap-1">
        {carrierName && (
          <p className="text-sm text-muted-foreground">{carrierName}</p>
        )}
        {trackingCode && (
          <a
            href={trackingCode}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-primary underline underline-offset-4"
          >
            {t("endProcess.carrier.trackReturn")}
          </a>
        )}
      </div>
    </motion.div>
  );
}
